import React from "react"
import all from "../../assets/images/inbox/all.svg"
import message from "../../assets/images/inbox/direct-message.svg"
import commentBoard from "../../assets/images/inbox/comment-board.svg"
import newsFeed from "../../assets/images/inbox/news-feed.svg"

export default function InboxLeftMenu(props) {
  const {
    handleInboxSelector,
    activeSection,
    selections,
    unreadMessages = 0,
    isNewsFeedEnabled,
  } = props

  return (
    <React.Fragment>
      <ul className="primary-input-nav">
        <li
          onClick={() => {
            handleInboxSelector(selections?.ALL_INBOX)
          }}
          className={activeSection === 0 ? "active" : ""}
        >
          <div className="icon-container">
            <img src={all} alt="Icon" className="icon-image" />
          </div>
          <h6 className="icon-label">All</h6>
        </li>
        <li
          onClick={() => {
            handleInboxSelector(selections?.COMMENT_BOARDS)
          }}
          className={`comment-board ${activeSection === 1 ? "active" : ""}`}
        >
          <div className="icon-container">
            <img src={commentBoard} alt="Icon" className="icon-image" />
          </div>
          <h6 className="icon-label">Comment Boards</h6>
        </li>
        <li
          onClick={() => {
            handleInboxSelector(selections?.DIRECT_MESSAGES)
          }}
          className={`direct-message ${activeSection === 2 ? "active" : ""}`}
        >
          <div className="icon-container">
            <img src={message} alt="Icon" className="icon-image" />

            {/* {unreadMessages > 0 && (
              <span className="icon-notification">{unreadMessages}</span>
            )} */}
          </div>
          <h6 className="icon-label">Direct Messages</h6>
        </li>
        {isNewsFeedEnabled ? (
          <li
            onClick={() => {
              handleInboxSelector(selections?.NEWS_FEEDS)
            }}
            className={`news-feed ${activeSection === 3 ? "active" : ""}`}
          >
            <div className="icon-container">
              <img src={newsFeed} alt="Icon" className="icon-image" />
            </div>
            <h6 className="icon-label">News Feed</h6>
          </li>
        ) : null}
      </ul>
    </React.Fragment>
  )
}
